import React, { FunctionComponent } from "react";
import { Link } from "gatsby";
import Image from "gatsby-image";
import { PostSnippet } from "../../types";
import { PostMeta } from "../postMeta";
import { formatDate, formatReadingTime } from "../../data/format";

export const CoverStory: FunctionComponent<PostSnippet> = ({
  title,
  summary,
  href,
  img,
  imgAlt,
  topic,
  type,
  publishedDate,
  readingTime,
}) => (
  <Link
    to={href}
    className="group grid grid-cols-1 border-b border-line lg:grid-cols-[7fr_5fr]"
  >
    <div className="h-[280px] md:h-[420px] lg:h-[560px]">
      <Image fluid={img} alt={imgAlt || title} style={{ height: "100%" }} />
    </div>
    <div className="flex flex-col justify-center gap-5 px-gutter-sm py-10 md:p-12">
      <PostMeta topic={topic} type={type} />
      <h2 className="font-display text-display-sm font-extrabold transition-colors duration-maker ease-maker group-hover:text-spark md:text-display">
        {title}
      </h2>
      <p className="text-[19px] leading-[1.6] text-ink-soft">{summary}</p>
      <div className="font-display text-[13px] text-muted">
        {formatDate(publishedDate)} · {formatReadingTime(readingTime)}
      </div>
    </div>
  </Link>
);
